<template>
  <div class="company-library-wrapper">
    <h2 class="title">Document Library</h2>
    <p class="content has-text-weight-bold">
      All of your saved documents in one place. In your library, you can add and delete documents that you frequently use.
    </p>

    <div class="columns">
    <div class="column is-two-fifths">
      <h3 class="subtitle">Add new files to your library</h3>
      <file-upload :companyKey="accountInfo.company.companyKey" :can-pick-from-lib="false"/>

      <truckl-documents/>
    </div>
      <div class="column">
        <h3 class="subtitle">Your Documents</h3>
      <documents-table />
      </div>
    </div>

  </div>
</template>

<script>
import DocumentsTable from '@/components/CompanyDocumentsTable/index'
import FileUpload from '@/components/DocumentUploader'
import TrucklDocuments from '@/components/TrucklDocuments'
import { mapGetters } from 'vuex'

export default {
  name: 'Documents-List',

  computed: {
    ...mapGetters('user', ['accountInfo'])
  },

  components: {
    DocumentsTable,
    FileUpload,
    TrucklDocuments
  }
}
</script>

<style scoped lang="scss">
.company-library-wrapper::after {
  // TODO: this would be great as a mix-in
  content: '';
  background-image: url('../../assets/backgrounds/shutterstock_474812767.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.4;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: fixed;
  z-index: -1;
}

.library-upload-wrapper {
  width: 50%;
  margin: 0 auto 50px auto;
}

.subtitle {
  font-weight: bolder;
}

.next-btn {
  margin-top: 25px;
  width: 280px;
}
</style>
